import type { FunctionComponent } from 'react';

import { Link } from '@dr.pogodin/react-utils';

import './style.scss';

type PropsT = {
  onSkip?: () => void;
  progress: number;
  stage?: string;
  subTitle: string;
  title: string;
};

export const ChatPageHeader: FunctionComponent<PropsT> = ({
  onSkip,
  progress,
  stage,
}) => (
  <div>
    <div styleName="header">
      {stage ? (
        <div styleName="stageName">
          {stage}
        </div>
      ) : null}
      {onSkip ? (
        <Link onClick={onSkip} styleName="skipLink" to="">
          Skip
        </Link>
      ) : null}
    </div>
    <div styleName="progressBar">
      <div
        style={{ width: `${100 * progress}%` }}
        styleName="progressBarValue"
      />
    </div>
  </div>
);
